// Placeholder fox from the prototype. The handoff asks for an illustrated mascot at the same sizes later.
export function Fox({ size, ring = false }: { size: number; ring?: boolean }) {
  return (
    <span className={`fox${ring ? ' fox--ring' : ''}`} style={{ width: size, height: size }} aria-hidden>
      <svg width={size} height={size} viewBox="0 0 40 40" style={{ display: 'block' }}>
        <circle cx="20" cy="20" r="20" fill="#ffe9d6" />
        <polygon points="8,5 17,15 5,18" fill="#e8742c" />
        <polygon points="32,5 23,15 35,18" fill="#e8742c" />
        <polygon points="9,9 14,15 8,16" fill="#3a2418" />
        <polygon points="31,9 26,15 32,16" fill="#3a2418" />
        <path d="M5 17 L20 12 L35 17 L29 28 L20 35 L11 28 Z" fill="#f28c3e" />
        <path d="M5 17 L14 24 L20 35 L11 28 Z" fill="#ffffff" />
        <path d="M35 17 L26 24 L20 35 L29 28 Z" fill="#ffffff" />
        <rect x="10" y="17.5" width="8.5" height="5" rx="2.2" fill="#171a21" />
        <rect x="21.5" y="17.5" width="8.5" height="5" rx="2.2" fill="#171a21" />
        <rect x="18" y="18.6" width="4" height="1.3" fill="#171a21" />
        <rect x="11.5" y="18.5" width="3" height="1.2" rx=".6" fill="#ffffff" opacity=".55" />
        <circle cx="20" cy="31" r="1.9" fill="#3a2418" />
      </svg>
    </span>
  );
}
